/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Privacy_LinkInputs */

const en_consent_privacy_link = /** @type {(inputs: Consent_Privacy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read our Privacy Policy`)
};

/**
* | output |
* | --- |
* | "Read our Privacy Policy" |
*
* @param {Consent_Privacy_LinkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const consent_privacy_link = /** @type {((inputs?: Consent_Privacy_LinkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Privacy_LinkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_consent_privacy_link(inputs)
});